//
// This form is currently used on a legacy page, so
// legacy apollo client is currently being used.
//

import React from "react";
import PropTypes from "prop-types";
import { useQuery } from "@apollo/client";

import SubscriptionLinks from "./SubscriptionLinks";
import InvoiceInformation from "./InvoiceInformation";
import PrepaidBalance from "./PrepaidBalance";
import StripePortalElement from "./StripePortalElement";

import { apolloClient } from "js/apollo/apollo-client";
import { GET_CURRENT_USER_WITH_BILLING, GET_SAVED_CARD } from "./queries";

const BillingForm = ({
    args: { isTeamPage, hasTeam, team } // from Django template: accounts/settings_plan.html
}) => {
    const { data: userData } = useQuery(GET_CURRENT_USER_WITH_BILLING, {
        client: apolloClient,
        fetchPolicy: "network-only"
    });
    const user = userData && userData.currentUser;

    const organizationId = isTeamPage ? team.id : null;
    const { data: stripeData } = useQuery(GET_SAVED_CARD, {
        client: apolloClient,
        fetchPolicy: "network-only",
        variables: {
            organizationId
        }
    });
    const stripe = stripeData && stripeData.savedCard;

    if (!user) {
        return null;
    }

    const {
        username,
        email,
        csrf,
        activeSubscription,
        hasPrepaidBalance = false,
        totalPrepaidBalanceAvailableCents
    } = user;

    const hasSavedCard = !!(stripe && stripe.id);
    const hasPaypal = !!(activeSubscription && activeSubscription.paypalId);
    const billingInfo =
        stripe && stripe.receiptInfo ? stripe.receiptInfo : null;
    const canSaveVAT = hasSavedCard || hasPaypal || !!billingInfo;

    const showPrepaidBalance = hasPrepaidBalance && !isTeamPage;
    const showSubscriptionLinks =
        !!activeSubscription && (!hasTeam || isTeamPage);

    const activeUsername = isTeamPage ? team.username : username;

    return (
        <div>
            {showPrepaidBalance && (
                <PrepaidBalance
                    totalPrepaidBalanceAvailableCents={
                        totalPrepaidBalanceAvailableCents
                    }
                />
            )}
            <StripePortalElement organizationId={organizationId} />
            {showSubscriptionLinks && (
                <SubscriptionLinks
                    activeUsername={activeUsername}
                    email={email}
                    csrf={csrf}
                    {...activeSubscription}
                />
            )}
            <InvoiceInformation
                canSaveVAT={canSaveVAT}
                billingInfo={billingInfo}
                organizationId={organizationId}
            />
        </div>
    );
};

BillingForm.propTypes = {
    args: PropTypes.object.isRequired
};

export default BillingForm;
